import React, { FC, useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import { PageTitle, Logo } from "@components/common";
import { PasswordRecovery as PasswordRecoveryForm } from "@components/form";
import StatusCard from "@components/main/resetPassword";

const PasswordRecovery: FC = () => {
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);

  const handleSuccess = useCallback(() => setSuccess(true), []);

  return (
    <Box component="main" pt={6}>
      <PageTitle title={t("auth.passwordRecovery")} />

      <Container maxWidth="sm">
        <Paper>
          <Stack direction="column" p={4} rowGap={3}>
            <Stack alignItems="center" direction="column" rowGap={2}>
              <Link to="/login">
                <Logo height={80} width={80} type="green0meter-with-csob" />
              </Link>

              {success ? (
                <StatusCard
                  icon={<CheckCircleOutlineIcon fontSize="inherit" />}
                  color="success.main"
                  shadowColor="rgba(76,175,80,0.35)"
                  title={t("auth.resetLinkSent")}
                />
              ) : (
                <>
                  <Typography variant="title">
                    {t("auth.passwordRecovery")}
                  </Typography>

                  <Typography variant="text" px={5} textAlign="center">
                    {t("auth.resetLinkDescription")}
                  </Typography>
                </>
              )}
            </Stack>

            {!success && <PasswordRecoveryForm onSuccess={handleSuccess} />}
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default PasswordRecovery;
